import type { ComponentProps } from 'react'
import { cn } from '../cn.ts'

/** React 19: `ref` is a regular prop and reaches the <input>. */
export function Input({ className, ...rest }: ComponentProps<'input'>) {
  return (
    <input
      className={cn(
        'h-10 w-full rounded-pill border border-line-2 bg-card px-4 text-sm text-text-1',
        'placeholder:text-meta transition-[border-color] duration-150 ease-out',
        'focus:border-pop focus:outline-none focus-visible:outline-none focus:ring-2 focus:ring-pop/25',
        className,
      )}
      {...rest}
    />
  )
}
